import { CSSProperties } from 'react';
import type { Corners, FrameAlignment } from '../../content-composer/types';

export const getCorners = (corners?: string): Corners => {
  const validCorners = ['square', 'rounded', 'pill'];
  return corners && validCorners.includes(corners) ? (corners as Corners) : 'square';
};

export const getAlignment = (alignment?: string): FrameAlignment => {
  const validAlignments = ['center', 'left', 'right'];
  return alignment && validAlignments.includes(alignment) ? (alignment as FrameAlignment) : 'center';
};

export const getPadding = (
  paddingTop?: string,
  paddingRight?: string,
  paddingBottom?: string,
  paddingLeft?: string
): CSSProperties => ({
  paddingTop: getNonNegativeNumber(paddingTop),
  paddingRight: getNonNegativeNumber(paddingRight),
  paddingLeft: getNonNegativeNumber(paddingLeft),
  paddingBottom: getNonNegativeNumber(paddingBottom),
});

export const getNonNegativeNumber = (input?: string | number) => {
  if (input === undefined || input === null) return undefined;

  if (typeof input === 'number') {
    return input >= 0 ? input : undefined;
  }

  const sanitizedInput = input.replace(/[^\d.-]/g, '').trim();
  const parsedInput = parseFloat(sanitizedInput);
  return !isNaN(parsedInput) && parsedInput >= 0 ? parsedInput : undefined;
};
